// extracted by mini-css-extract-plugin
export default {"background":"login_background__lRV05","noBackground":"login_noBackground__PwY3+","title":"login_title__yX9NU","button":"login_button__b1+KQ","verifyCode":"login_verifyCode__C2oMJ"};